<template>
  <div>
    <template v-for="item in menuItems">
      <v-list-item
        :key="item.text"
        :to="item.to"
        :exact="item.exact"
      >
        <v-list-item-action>
          <v-icon v-if="item.icon">
            {{ item.icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    menuItems: {
      type: Array,
      default: () => []
    }
  }
}
</script>
